import styled from '@emotion/styled';

export const TableContainer = styled.div`
	width: 100%;
`;
export const Table = styled.table`
	display: grid;
	grid-template-columns: minmax(8rem, 10rem) minmax(20rem, 1fr) minmax(8rem, 10rem) minmax(8rem, 10rem) minmax(12rem, 16rem);
	grid-auto-rows: minmax(52px, auto);
	max-width: 100%;
	width: 100%;
`;
export const TableHeaderCell = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1rem 1.2rem;
	background-color: #f8f9fa;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	min-width: 10rem;
`;
export const TableCell = styled.div`
	height: 8rem;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	cursor: pointer;
	border-bottom: 1px solid rgba(173, 181, 189, 0.4);
	overflow: hidden;
	&.start {
		justify-content: flex-start;
	}
`;

export const LabelImportant = styled.span`
	display: flex;
	align-items: center;
	padding: 0rem 0.8rem;
	border-radius: ${(props) => props.theme.borderRadius.pill};
	background: #01337d;
	height: 2.8rem;
	color: white;
	font-size: 1.4rem;
	font-weight: 700;
`;
